import { CustomFormControlDefinition } from '../../../shared/utils/custom-form-control';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { SelectAdaptor } from '../input-control/input-control.component';

@Component({
	selector: 'app-floating-label-input',
	templateUrl: './floating-label-input.component.html',
	styleUrls: ['./floating-label-input.component.scss']
})
export class FloatingLabelInputComponent implements OnInit {

	@Input() controlDef: CustomFormControlDefinition;
	@Input() iconPosition: 'right' | 'left';
	@Input() defaultSelectedItem: any;
	@Input() selectedItem: any;
	@Input() label: string;
	@Input() errorMessage: string;
	@Input() selectItems: SelectAdaptor[];
	@Input() placeHolder: string;
	@Input() content: TemplateRef<any>;
	@Input() selectOptionsItems: any[];
	@Input() selectOptionsTemplate: TemplateRef<any>;
	@Input() suffixType: string;
	@Input() prefixType: string;
	@Input() disabledDate;
	@Output() emitOnChanged = new EventEmitter();
	@Output() getBvnDetails = new EventEmitter();
	@Output() blurred = new EventEmitter();
	@Input() isLoadingItems: boolean;
	@Input() disabled: boolean;
	// kuwego field extension
	@Input() isKuwegoLoanBvn: boolean;
	@Input() maxBvnLength: number;
	@Input() isDisableFocus: boolean;
	@Input() errorInBvn: any;
	@Output() resetBvnDetails = new EventEmitter();
	@Output() openChange: EventEmitter<any> = new EventEmitter();
	// **************************************** */
	labelClass: string;
	showPlaceHolder = false;
	firstFocus = false;
	isEmpty: boolean;
	indentInput: boolean;
	indentClass = '';
	validForm: boolean;

	constructor() { }

	ngOnInit(): void {
		if (this.prefixType) {
			this.indentInput = true;
			this.indentClass = 'prefix-indentation';
		}
		this.setLabelClassOnInputField();
	}

	setLabelClassOnInputField() {
		if (
			!this.controlDef || !this.controlDef.formGroupControl ||
			!this.controlDef.formGroupControl?.value
		) {
			this.labelClass = 'label as-placeholder';
		} else {
			this.labelClass = 'label as-label';
		}
	}
	// To control the value for a default input field.
	setLabelForDefaultInputField() {
		if (this.isDisableFocus) {
			this.labelClass = 'label as-label';
		} else {
			this.labelClass = 'label as-placeholder';
		}
	}
	onInputValueChanged(def: CustomFormControlDefinition) {
		const isRequired = this.controlDef.required;
		if (!this.validForm && isRequired) {
			this.showPlaceHolder = true;
			this.labelClass = 'label as-label-onError';
		}
		else {
			this.showPlaceHolder = false;
			if (!def || !def.formGroupControl || !def.formGroupControl.value) {
				this.labelClass = 'label as-placeholder';
			} else {
				this.labelClass = 'label as-label-onfocus';
			}
		}
		this.emitOnChanged.emit(def?.formGroupControl?.value);
	}

	onInputFocused(def) {
		const isRequired = this.controlDef.required;
		this.labelClass = 'label as-label-onfocus';
		if (!this.validForm && isRequired) {
			this.showPlaceHolder = true;
			this.labelClass = 'label as-label-onError';
		}
		this.emitOnChanged.emit(def?.formGroupControl?.value);
	}

	onBlurred(def) {
		const isRequired = this.controlDef.required;
		if (!this.validForm && isRequired) {
			this.showPlaceHolder = true;
			this.labelClass = 'label as-label-onError';
		}
		else {
			if (!def) {
				this.labelClass = 'label as-placeholder';
			} else {
				this.labelClass = 'label as-label';
			}
		}
		// this.emitOnChanged.emit(def?.formGroupControl?.value);
		this.blurred.emit(def?.formGroupControl?.value);
	}

	setFormValidity($event: boolean) {
		this.validForm = $event;
	}
	getFloatingBvnDetails($event) {
		this.getBvnDetails.emit($event);
	}
	floatResetBvnDetails($event) {
		this.resetBvnDetails.emit();
	}
}
